import Vue from 'vue'
import { PopupManager } from 'element-ui/src/utils/popup'
import UmExport from './index.vue'
const ExportConstructor = Vue.extend(UmExport) // 直接将Vue组件作为Vue.extend的参数

let instance
const instances = []
let seed = 1

const ExportFile = (options) => {
  options = options || {}
  const id = 'export_' + seed++
  instance = new ExportConstructor({
    propsData: {
      isPdf: !!options.isPdf
    },
    data: {
      progressParamData: options.progressParamData || {},
      progressBusinessCode: options.progressBusinessCode || null
    }
  }) // 实例化
  instance.id = id
  instance.$mount()
  document.body.appendChild(instance.$el)
  // instance.visible = true
  instance.$el.style.zIndex = PopupManager.nextZIndex()
  instances.push(instance)

  // 开始下载
  instance.download()

  return instance
}
ExportFile.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].$destroy(true)
  }
}

export default {
  install: Vue => {
    Vue.prototype.$exportFile = ExportFile // 将组件暴露出去，并挂载在Vue的prototype上
  }
}
